<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <!--
          <el-form-item label="" class="pr-10">
            <el-select
              v-model="queryForm.branchId"
              clearable
              placeholder="分店"
            >
              <el-option
                v-for="item in branchList"
                :key="item.branchId"
                :label="item.title"
                :value="item.branchId"
              ></el-option>
            </el-select>
          </el-form-item>
        -->
        <el-form-item label="" class="pr-10">
          <el-input v-model="queryForm.patrolRecordNo" placeholder="申请编号" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="" class="pr-10">
          <el-select v-model="queryForm.mode" placeholder="请假类型" clearable>
            <el-option
              v-for="item in modes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" class="pr-10">
          <el-select v-model="queryForm.createdPeopleId" placeholder="申请人" clearable>
            <el-option
              v-for="item in staffs"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" class="pr-10">
          <el-date-picker
            v-model="queryForm.startDate"
            type="date"
            placeholder="开始提交日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="" class="pr-10">
          <el-date-picker
            v-model="queryForm.endDate"
            type="date"
            placeholder="结束提交日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="" class="pr-10">
          <el-date-picker
            v-model="queryForm.startOpTime"
            type="datetime"
            placeholder="开始巡查日期"
          />
        </el-form-item>
        <el-form-item label="" class="pr-10">
          <el-date-picker
            v-model="queryForm.endOpTime"
            type="datetime"
            placeholder="结束巡查日期"
          />
        </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column
        align="left"
        label="申请编号"
        prop="basic.patrolRecordNo"
        show-overflow-tooltip
      />
      <!--
      <el-table-column
        align="left"
        label="门店"
        prop="branch.title"
        show-overflow-tooltip
      />
    -->
      <el-table-column
        align="left"
        label="巡查类别"
        prop="title"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ formatMode(row.action) }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="备注"
        prop="basic.text"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="提交时间"
        prop="createdTime"
        show-overflow-tooltip
        width="180"
      >
        <template #default="{ row }">
          {{ moment(row.createdTime).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleDetail(detail, row)">
            详情
          </el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
   
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <detail ref="detail" @fetch-data="fetchData" />
  </div>
</template>

<script>
import Detail from './detail.vue'
import moment from 'moment'
import { findPatrolRecordList,removePatrolRecord } from '@/api/oa'
import { findList, } from '@/api/staff'
import { getAllBranchs } from '@/api/branch'
import { reactive, ref, getCurrentInstance } from 'vue'
import commomFunction from '../common'

export default {
  name: 'OaCarIndex',
  components: { Detail },
  setup() {
    const { proxy } = getCurrentInstance()
    const list = reactive([])
    const branchList = reactive([])
    const modes = [{
      label: '查铺查岗',
      value: 1,
    }, {
      label: '夜岗巡查',
      value: 2,
    }, {
      label: '队容风纪',
      value: 3,
    }, {
      label: '执勤战备',
      value: 4,
    }]
    const staffs = []
    const listLoading = ref(true)
    const layout = 'total, sizes, prev, pager, next, jumper'
    const total = ref(0)
    const { staffList } = commomFunction()
    const queryForm = reactive({
      page: 1,
      size: 10,
      createPeopleId: '',
      followPeopleId: '',
      filterMode: 3,
      branchId: '',
      step: '',
      keyword: '',
    })
    const detail = ref(null)
    const fetchData = async () => {
      listLoading.value = true
      queryForm.startOpTime=queryForm.startOpTime?moment(queryForm.startOpTime).format('YYYY-MM-DD HH:mm:ss'):''
      queryForm.endOpTime=queryForm.endOpTime?moment(queryForm.endOpTime).format('YYYY-MM-DD HH:mm:ss'):''
      const { list: list1, total: total1 } = await findPatrolRecordList(
        queryForm
      )
      list.length = 0
      list.push(...list1)
      total.value = total1
      listLoading.value = false
    }
    const queryData = () => {
      queryForm.page = 1
      fetchData()
    }
    const formatMode = (mode) => {
      const find = modes.find(e => e.value == mode)
      return find && find.label || '未知'
    }
    //添加和编辑
    const handleDetail = (detail, row) => {
      detail.showDetail(row)
    }
    const getAllBranchList = async () => {
      const res = await getAllBranchs({})
      if (!res) return
      branchList.length = 0
      branchList.push(...res)
    }
    const getAllStaffs = async () => {
      const res = await findList({
        page: 1,
        size: 100,
      })
      if (!res) return
      staffs.push(...res.list.map(e => ({
        label: e.basic.name,
        value: e.peopleId,
      })))
    }
    const handleDelete = (row) => { 
      proxy.$baseConfirm(
        `你确定要删除人员申请记录吗`,
        null,
        async () => {
          await removePatrolRecord({
            patrolRecordId: row.patrolRecordId,
          })
          proxy.$baseMessage(
            `删除车人员申请记录成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          queryData()
        }
      )
    }
    //分页
    const handleSizeChange = (val) => {
      queryForm.size = val
      fetchData()
    }
    const handleCurrentChange = (val) => {
      queryForm.page = val
      fetchData()
    }
    getAllBranchList()
    getAllStaffs()
    //拉取数据
    queryData()
    return {
      list,
      listLoading,
      layout,
      total,
      modes,
      staffs,
      queryForm,
      moment,
      detail,
      staffList,
      branchList,
      fetchData,
      queryData,
      formatMode,
      handleDetail,
      handleDelete,
      handleSizeChange,
      handleCurrentChange,
    }
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
